import {HttpClient} from '@angular/common/http';
import {Inject, Injectable} from '@angular/core';
import {WicketWalletPaginatedResponse} from '@tisa-group/models';
import {WicketNft} from '@tisa-group/models/wicket/wicket-nft';
import {TISA_WICKET_V2_API_URL} from '../tisa-wicket.providers';

@Injectable({
  providedIn: 'root',
})
export class NftApiService {
  constructor(
    protected readonly httpClient: HttpClient,
    @Inject(TISA_WICKET_V2_API_URL) readonly wicketV2Url: string | (() => string),
  ) {}

  getUserNfts(lastEvaluatedKey?: string) {
    const params: {page_size: number; last_evaluated_key?: string} = {page_size: 15};

    if (lastEvaluatedKey) {
      params.last_evaluated_key = lastEvaluatedKey;
    }

    return this.httpClient.get<WicketWalletPaginatedResponse<WicketNft>>(
      `${
        this.wicketV2Url instanceof Function ? this.wicketV2Url() : this.wicketV2Url
      }/wallet/user/nfts`,
      {params},
    );
  }
}
